import { Commit } from "components/icons/generated";
import MetaInfoListItem from "components/MetaInfoList/Item";
import { Commit as CommitType, Maybe, VcsProvider } from "types/generated";
import { getCommitLabel } from "utils/commit";

type MetaInfoSpaceliftCommitProps = {
  commit: Maybe<Pick<CommitType, "hash" | "url">>;
  commitSetBy: Maybe<string>;
  provider: VcsProvider;
};

const MetaInfoSpaceliftCommit = ({
  commit,
  commitSetBy,
  provider,
}: MetaInfoSpaceliftCommitProps) => {
  if (!commit) return null;

  return (
    <MetaInfoListItem
      href={commit.url}
      linkText={getCommitLabel(provider, commit.hash)}
      icon={Commit}
      tooltip={commitSetBy}
      target="_blank"
    />
  );
};

export default MetaInfoSpaceliftCommit;
